import styles from "./styles.module.css";
import { Link, Typography, Divider } from "@mui/material";
import * as React from "react";
import Grid from "@mui/material/Grid";
import { useTranslation } from "react-i18next";
import ImageHeroResources from "../../assets/images/heros/resources.jpg";
import { apiDocumentList } from "../../api";
import PageImageHero from "../../components/PageImageHero/PageImageHero";
import Box from "@mui/material/Box";
import LanguageChip from "../../components/LanguageChip/LanguageChip";
import { DocumentType } from "../../enums";
import Masonry from "@mui/lab/Masonry";

const BACKEND_BASE_URL = new URL(process.env.REACT_APP_TOWERS_API_URL).origin;

function ResourcesPage() {
  const [t, i18n] = useTranslation("common");

  const [documents, setDocuments] = React.useState(undefined);

  React.useEffect(() => {
    apiDocumentList(undefined, undefined, [
      DocumentType.GENERAL,
      DocumentType.GUIDE,
      DocumentType.RESOURCE,
    ]).then((response) => {
      if (response.status === 200) {
        setDocuments(response.data);
      }
    });
  }, [setDocuments, i18n.resolvedLanguage]);

  const content = (
    <Masonry
      columns={{ xs: 1, sm: 2, md: 4 }}
      spacing={4}
      className={styles.resourcesGrid}
    >
      {documents &&
        documents.results.length > 0 &&
        documents.results.map((document: any) => {
          return (
            <Box key={document.id} className={styles.resourcesGridItem}>
              <Link
                href={BACKEND_BASE_URL + document.file}
                underline="none"
                color="textPrimary"
              >
                <img
                  src={BACKEND_BASE_URL + document.preview.medium}
                  className={styles.resourcesFileImage}
                  alt={document.name}
                />
                <Divider />
                <Box className={styles.resourcesFileTitle}>
                  <Box>
                    <Typography
                      variant="body2"
                      fontWeight="600"
                      component="span"
                      paddingRight="8px"
                    >
                      {document.name}
                    </Typography>
                    <LanguageChip
                      language={document.language}
                      size="small"
                      marginLeft={0}
                    />
                  </Box>
                </Box>
              </Link>
            </Box>
          );
        })}
    </Masonry>
  );

  return (
    <PageImageHero
      title={t("pages.resources.title")}
      content={content}
      hero={ImageHeroResources}
      loading={!documents}
    />
  );
}

export default ResourcesPage;
